export default __webpack_public_path__ + "static/media/twitter.059892de.svg";